// removes the -2 or -2/ from the end of a slug
// generated by WordPress when a post or page has the same slug as another post or page
export function cleanSlug(slug) {
  if (slug.endsWith('-2/')) {
    return slug.slice(0, -3) + '/';
  } else if (slug.endsWith('-2')) {
    return slug.slice(0, -2);
  }
  return slug;
}
